module.exports = __webpack_public_path__ + "img/banner.21af4989.jpg";